import React from "react";
import CourseBlock from "./CourseBlock"
import { COURSE_LIST_WIDTH } from "../../constants/cssConstants";
import compareArrays from "../../utils/compareArrays";
import { LIST_TITLE_HEIGHT } from "../../constants/cssConstants";
import sortCourses from "../../utils/sortCourses";
import {Skeleton} from "@material-ui/lab";

const getLoadingSkeletons = function() {
    const result = [];
    for(let i = 0; i < 40; i++) {
        result.push(
            <div style={{padding: '7px 0px 7px 14px'}}>
                <Skeleton variant={"rect"} width={221} height={46} />
            </div>
        )
    }
    return result;
}

class CourseLists extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            height: props.height,
            courses: props.courses,
            changed: props.changed
        }
        this.loadingSkeleton = getLoadingSkeletons();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.height !== this.props.height || !compareArrays(prevProps.courses, this.props.courses)
            || prevProps.changed !== this.props.changed) {
            this.setState({
                height: this.props.height,
                courses: this.props.courses,
                changed: this.props.changed
            })
        }
    }

    render() {
        const LIST_HEIGHT = this.state.height - (this.props.listTitle !== "" ? LIST_TITLE_HEIGHT : 0);
        const sortedCourses = sortCourses(this.state.courses)
        return(
            <div style={{ height: this.state.height, backgroundColor: "#C4C4C4", overflow: "hidden" }}>
                {
                    this.props.listTitle !== "" &&
                    <div style={{
                        height: LIST_TITLE_HEIGHT, backgroundColor: '#182B49', display: 'flex',
                        alignItems: 'center', justifyContent: 'center'
                    }}>
                        <div style={{color: 'white', fontWeight: 'bold', fontSize: 24}}>{this.props.listTitle}</div>
                    </div>
                }
                <div
                    style={{
                        height: LIST_HEIGHT,
                        width: COURSE_LIST_WIDTH,
                        display: "inline-block",
                        overflowY: "scroll"
                    }}
                >
                    {
                        this.state.courses.length === 0
                            ? this.loadingSkeleton
                            : sortedCourses.map((course) =>
                                <CourseBlock
                                    courseCode={ course.course_code }
                                    courseName={ course.name }
                                    fromSearchList={this.props.fromSearchList}
                                    addToPlanCoursesList={this.props.addToPlanCoursesList}
                                    course={course}
                                />
                            )
                    }
                </div>
            </div>
        );
    }
}

export default CourseLists;